import React, { useState } from "react";
import { Avatar, Box, Button, Card, CardContent, Checkbox, Container, Divider, FormControl, FormControlLabel, FormGroup, Grid, Grid2, InputLabel, Link, MenuItem, Modal, Select, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from "@mui/material";
import Layout from "./Layout";
import CheckCircle from '@mui/icons-material/CheckCircle';
import Paper from '@mui/material/Paper';
import StatusChip from "./StatusChip";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DateField } from "@mui/x-date-pickers";
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import FileDownload from '@mui/icons-material/FileDownload';
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { pathOr } from "ramda";
import { leadStatusNum } from "../helpers/status";
import { approveAssignment, raiseFr, rejectAssignment, updateAlternateNumber, uploadAadhaarDocument, uploadDocument, uploadSelfie } from "../actions/leadsAction";
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RejectionChip from "./RejectionChip";
import dayjs from "dayjs";

const AddEditLeads = () => {
  const { id } = useParams()
  const { leads } = useSelector(state => state.Leads)
  const policy = leads.filter(l => l._id === id)[0]
  const [checked, setChecked] = useState(false)
  const [reason, setReason] = useState("")
  const [comment, setComment] = useState("")
  const dispatch = useDispatch();
  const [alternateNumber, setAlternateNumber] = useState(policy.alternateNumber)
  const [message, setMessage] = useState("")




  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const NumericFormatCustom = React.forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;



      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
          prefix="₹"
        />
      );
    },
  );

  NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };


  const [isVerify, setVerify] = useState(false);
  const [isReject, setReject] = useState(false);
  const [isFR, setFr] = useState(false);

  const handleApprove = () => {
    const body = { policyId: id }
    dispatch(approveAssignment(body));
    setVerify(false)
  }

  const handleReject = () => {
    const body = { policyId: id, reason }
    dispatch(rejectAssignment(body));
    setReject(false)
  }

  const handleFr = () => {
    const body = { policyId: id, reason }
    dispatch(raiseFr(body));
    setReject(false)
  }

  const handleUpload = async (files) => {
    console.log(files[0])
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = async function () {
      console.log(reader.result.split("base64,")[1]);
      dispatch(uploadDocument({ file: reader.result.split("base64,")[1], policyId: id }))
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const uploadAadhaar = async (files) => {
    console.log(files[0])
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = async function () {
      console.log(reader.result.split("base64,")[1]);
      dispatch(uploadAadhaarDocument({ image: reader.result.split("base64,")[1], policyId: id, type: 'AADHAAR' }))
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  const uploadPhoto = async (files) => {
    console.log(files[0])
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = async function () {
      console.log(reader.result.split("base64,")[1]);
      dispatch(uploadSelfie({ photo: reader.result.split("base64,")[1], policyId: id }))
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: '#F7FAF5',
    //   border: '2px solid #000',
    boxShadow: 24,
    p: 4

  };

  const getAadharLink = () => {
    const aadhaar = pathOr([], ["kycs", "0", "documents",], policy).filter(d => d.kycDocs.identifier === 'Proof of Possession of Aadhaar')
    return pathOr("", ["0", "kycDocs", "location"], aadhaar)
  }
  const getSelfieLink = () => {
    const selfie = pathOr([], ["kycs", "0", "documents",], policy).filter(d => d.kycDocs.identifier === 'Selfie')
    return pathOr("", ["0", "kycDocs", "location"], selfie)
  }

  const signedAgreementLink = () => {
    return pathOr("", ["assignments", "0", "signedDocument"], policy)
  }

  const assignmentConfirmationLink = () => {
    return pathOr("", ["assignments", "0", "assignmentConfirmation"], policy)
  }
  const handleInputChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {

      setAlternateNumber(value)
      // Regular expression to match exactly 10 digits
      const regex = /^\d{10}$/;
      if (value.length === 0 || regex.test(value)) {
        setMessage('');
      } else {
        setMessage('Mobile number must be exactly 10 digits.');
      }
    } else {
      setMessage('Only digits are allowed.');
    }

  };
  return (
    <>
      <Layout>
        <React.Fragment>
          <Container>
            <Grid2 container alignItems={"center"} justifyContent={'space-between'}>
              <Grid2 item>
                <Typography variant="h4" mt={2} mb={2}>{"Policy Details - " + policy.policyNumber}</Typography>
              </Grid2>
            </Grid2>
            <Paper>
              <Grid2 container>
                <Grid2 item p={2}>
                  <StatusChip isActive={policy.smsSent} text="SMS Sent" />
                </Grid2>
                <Grid2 item p={2}>
                  <StatusChip isActive={pathOr(false, ['assignments', '0', 'isSigned'], policy)} text="E-sign Completed" />
                </Grid2>
                <Grid2 item p={2}>
                  <StatusChip isActive={pathOr(false, ['assignments', '0', 'isSigned'], policy)} text="Signed Document Received" />
                </Grid2>
                {pathOr("", ['assignments', '0', 'status'], policy) === 'rejected' && (
                  <Grid2 item p={2}>
                    <RejectionChip isActive={pathOr("", ['assignments', '0', 'status'], policy) === 'rejected'} text="Rejected" />
                  </Grid2>
                )}
                {pathOr("", ['assignments', '0', 'status'], policy) !== 'rejected' && (
                  <Grid2 item p={2}>
                    <StatusChip isActive={leadStatusNum(policy) >= 8} text="Signed Document Verified" />
                  </Grid2>
                )}
                <Grid2 item p={2}>
                  <StatusChip isActive={leadStatusNum(policy) >= 9} text="Assignment Copy Upload" />
                </Grid2>
                <Grid2 item p={2}>
                  <StatusChip isActive={leadStatusNum(policy) >= 9} text="Money Disbursed" />
                </Grid2>
              </Grid2>

              <Box m={1} p={2} sx={{ background: '#F7FAF5' }}>
                <Typography mb={3}>{"Policy Details"}</Typography>
                <form>

                  <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                    <Grid2 item size={4}>
                      <TextField disabled fullWidth id="txtPolicyNumber" value={policy.policyNumber} label="Policy Number" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <FormControl fullWidth>
                        <InputLabel disabled id="lblPlanName">Plan Name</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="ddlPlanName"
                          value={0}
                          label="Plan Name"
                          fullWidth
                          disabled
                          onChange={() => { }}
                        >
                          <MenuItem value={0}>{policy.planName}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 item size={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateField']}>
                          <DateField disabled fullWidth label="Commencement Date" value={dayjs(policy.commencementDate)}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField value={policy.term} disabled fullWidth id="txtPolicyTerm" label="Policy Term" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField value={policy.paymentTerm} disabled fullWidth id="txtPremiumTerm" label="Premium Term" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField value={policy.premium} disabled fullWidth id="txtPremium" label="Premium" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField value={policy.sumAssured} disabled fullWidth id="txtSumAssured" label="Sum Assured" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField disabled value={policy.data?.bonusTillDate ?? ''} fullWidth id="txtBonusAmount" label="Bonus Amount" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField value={policy.surrenderValue} disabled fullWidth id="txtSurrenderValue" label="Surrender Value" variant="outlined"
                        slotProps={{
                          input: {
                            inputComponent: NumericFormatCustom,
                          },
                        }}
                      />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField disabled value={policy.data?.pendingPremiumAmount ?? ''} fullWidth id="txtDuePayable" label="Due Payable" variant="outlined"
                        slotProps={{
                          input: {
                            inputComponent: NumericFormatCustom,
                          },
                        }}
                      />
                    </Grid2>
                    <Grid2 item size={4}>
                      <FormControl fullWidth>
                        <InputLabel disabled id="lblPolicyStatus">Policy Status</InputLabel>
                        <Select
                          labelId="lblStatus"
                          id="ddlStatus"
                          disabled
                          label="Policy Status"
                          fullWidth
                          value={policy.policyStatus}
                          onChange={() => { }}
                        >
                          <MenuItem value={policy.policyStatus}>{policy.policyStatus}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 item size={4}>
                      <FormControl fullWidth>
                        <InputLabel disabled id="lblPaymentFrequency">Payment Frequency</InputLabel>
                        <Select
                          labelId="lblFrequency"
                          id="ddlFrequency"
                          value={policy.paymentFrequency}
                          label="Payment Frequency"
                          fullWidth
                          disabled
                          onChange={() => { }}
                        >
                          <MenuItem value={policy.paymentFrequency}>{policy.paymentFrequency}</MenuItem>
                          <MenuItem value={2}>{'Half Yearly'}</MenuItem>
                          <MenuItem value={2}>{'Quaterly'}</MenuItem>
                          <MenuItem value={2}>{'Monthly'}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 item size={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateField']}>
                          <DateField disabled value={dayjs(policy.data?.premiumPaidUpto ?? '')} fullWidth label="Paid Upto" />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid2>
                    <Grid2 item size={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateField']}>
                          <DateField disabled value={dayjs(policy.data?.dueDate ?? '')} fullWidth label="Due Date" />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid2>
                  </Grid2>

                </form>
              </Box>

              <Box m={1} mt={4} p={2} sx={{ background: '#F7FAF5' }}>
                <Typography mb={3}>{"Customer Details"}</Typography>
                <form>
                  <FormControl sx={{ width: '100%' }}>
                    <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                      <Grid2 item size={4}>
                        <TextField disabled value={policy.policyHolderName} fullWidth id="txtFirstName" label="Name" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DateField']}>
                            <DateField disabled value={dayjs(policy.dob)} fullWidth label="Date Of Birth" />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField disabled fullWidth value={policy.policyHolderMobileNumber} id="txtMobile" label="Mobile Number" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField disabled fullWidth id="txtEmail" label="Email" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField fullWidth id="txtPincode" label="Pincode" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField fullWidth id="txtCity" label="City" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={12}>
                        <TextField fullWidth id="txtAddress" label="Address" variant="outlined" />
                      </Grid2>
                      <TextField required onChange={(e) => {
                        handleInputChange(e)
                      }} fullWidth value={alternateNumber} id="txtAltMobile" label="Alternate Mobile Number" variant="outlined" />
                      {message && (
                        <p style={{ color: message === 'Mobile number is valid.' ? 'green' : 'red' }}>
                          {message}
                        </p>
                      )}
                      <Box>
                        <Button
                          component="label"
                          type="button"
                          variant="contained"
                          tabIndex={-1}
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(updateAlternateNumber({ alternateNumber, policyId:id }))
                          }}
                        >
                          SUBMIT

                        </Button>

                      </Box>
                    </Grid2>
                  </FormControl>
                </form>
              </Box>

              <Box m={1} mt={4} p={2} sx={{ background: '#F7FAF5' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                  <Typography >{"Bank Details"}</Typography>
                  <CheckCircle sx={{ color: '#66DA45' }} />
                </div>
                <form>
                  <FormControl sx={{ width: '100%' }}>
                    <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                      <Grid2 item size={4}>
                        <TextField value={pathOr("", ["kycs", "0", "bankAccount", "0", "accountNumber"], policy)} disabled fullWidth id="txtAccountNumber" label="Account Number" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField value={pathOr("", ["kycs", "0", "bankAccount", "0", "ifsc"], policy)} disabled fullWidth id="txtIFSC" label="IFSC Code" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField value={pathOr("", ["kycs", "0", "bankAccount", "0", "bank"], policy)} disabled fullWidth id="txtBankName" label="Bank Name" variant="outlined" />
                      </Grid2>
                    </Grid2>
                  </FormControl>
                </form>
              </Box>

              <Box m={1} mt={4} p={2} sx={{ background: '#F7FAF5' }}>
                <Typography mb={3} >{"Documents"}</Typography>
                <form>
                  <FormControl sx={{ width: '100%' }}>
                    <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                      {pathOr([], ["kycs", "0", "documents",], policy).filter(d => d.kycDocs.identifier === 'Proof of Possession of Aadhaar').length >= 1 ? (
                        <Grid2 item size={4}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Link target="_blank" sx={{ display: 'flex', textDecoration: 'none' }} href={getAadharLink()}><Button fullWidth sx={{ marginRight: 1, justifyContent: 'space-between' }} variant="outlined" endIcon={<FileDownload />}>{"AADHAAR"}</Button>
                              <CheckCircle sx={{ color: '#66DA45' }} /> </Link>
                          </div>
                        </Grid2>
                      ) : (
                        <Box sx={{ background: '#F7FAF5' }}>
                          <Typography>{"Upload Aadhaar"}</Typography>
                          <Grid2 container>
                            <Grid2 item size={12}>
                              <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                startIcon={<CloudUploadIcon />}
                              >
                                Upload files
                                <VisuallyHiddenInput
                                  type="file"
                                  onChange={(event) => uploadAadhaar(event.target.files)}
                                />
                              </Button>
                            </Grid2>
                          </Grid2>


                        </Box>
                      )}
                      {pathOr([], ["kycs", "0", "documents",], policy).filter(d => d.kycDocs.identifier === 'Selfie').length >= 1 ? (
                        <Grid2 item size={4}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Link target="_blank" sx={{ display: 'flex', textDecoration: 'none' }} href={getSelfieLink()}><Button fullWidth sx={{ marginRight: 1, justifyContent: 'space-between' }} variant="outlined" endIcon={<FileDownload />}>{"Photo"}</Button>
                              <CheckCircle sx={{ color: '#66DA45' }} /></Link>
                          </div>
                        </Grid2>
                      ) : (<Box>
                        <Typography>{"Upload Photo"}</Typography>
                        <Grid2 container>
                          <Grid2 item size={12}>
                            <Button
                              component="label"
                              role={undefined}
                              variant="contained"
                              tabIndex={-1}
                              startIcon={<CloudUploadIcon />}
                            >
                              Upload files
                              <VisuallyHiddenInput
                                type="file"
                                onChange={(event) => uploadPhoto(event.target.files)}
                              />
                            </Button>
                          </Grid2>
                        </Grid2>


                      </Box>)}
                      {pathOr("", ["assignments", "0", "signedDocument",], policy) != "" && (
                        <Grid2 item size={4}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Link target="_blank" sx={{ display: 'flex', textDecoration: 'none' }} href={signedAgreementLink()}><Button fullWidth sx={{ marginRight: 1, justifyContent: 'space-between' }} variant="outlined" endIcon={<FileDownload />}>{"E-sign"}</Button>
                              <CheckCircle sx={{ color: '#66DA45' }} /></Link>
                          </div>
                        </Grid2>
                      )}
                      {pathOr("", ["assignments", "0", "assignmentConfirmation",], policy) != "" && (
                        <Grid2 item size={4}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Link target="_blank" sx={{ display: 'flex', textDecoration: 'none' }} href={assignmentConfirmationLink()}><Button fullWidth sx={{ marginRight: 1, justifyContent: 'space-between' }} variant="outlined" endIcon={<FileDownload />}>{"Assignment Confirmation"}</Button>
                              <CheckCircle sx={{ color: '#66DA45' }} /></Link>
                          </div>
                        </Grid2>
                      )}
                    </Grid2>
                  </FormControl>
                </form>
              </Box>
              {leadStatusNum(policy) == 6 && pathOr("", ['assignments', '0', 'status'], policy) !== 'rejected' && (
                <Box m={1} mt={4} p={2}>
                  <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                    <Grid2 item size={4}>
                      <Button sx={{ background: '#4DA235' }} variant="contained" size="large" onClick={() => { setVerify(true) }}>
                        Verify Documents
                      </Button>
                    </Grid2>
                    <Grid2 item size={4}>
                      <Button sx={{ background: '#4DA235' }} variant="contained" size="large" onClick={() => { setReject(true) }}>
                        Reject Lead
                      </Button>
                    </Grid2>
                    <Grid2 item size={4}>
                      <Button sx={{ background: '#4DA235' }} variant="contained" size="large" onClick={() => { setFr(true) }}>
                        Raise FR
                      </Button>
                    </Grid2>
                  </Grid2>
                </Box>
              )}
              {policy.journeyStatus === "assigned" && (
                <Box m={1} mt={4} p={2} sx={{ background: '#F7FAF5' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                    <Typography >{"Disbursal Details"}</Typography>
                    <CheckCircle sx={{ color: '#66DA45' }} />
                  </div>
                  <form>
                    <FormControl sx={{ width: '100%' }}>
                      <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                        <Grid2 item size={4}>
                          <TextField value={pathOr("", ["kycs", "0", "bankAccount", "0", "accountNumber"], policy)} disabled fullWidth id="txtAccountNumber" label="Account Number" variant="outlined" />
                        </Grid2>
                        <Grid2 item size={4}>
                          <TextField value={Math.ceil((Math.random()) * 100000000)} disabled fullWidth id="txtIFSC" label="Transaction Id" variant="outlined" />
                        </Grid2>
                        <Grid2 item size={4}>
                          <TextField value={moment().format("DD-MM-YYYY")} disabled fullWidth id="txtBankName" label="Transaction Date" variant="outlined" />
                        </Grid2>
                      </Grid2>
                    </FormControl>
                  </form>
                </Box>
              )}
              {policy.journeyStatus === "document verified" && (
                <Box m={1} mb={4} mt={4} p={2} sx={{ background: '#F7FAF5' }}>
                  <Typography>{"Upload Assignment Copy"}</Typography>
                  <Grid2 container>
                    <Grid2 mb={2} mt={2} item size={12}>
                      <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                      >
                        Upload files
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(event) => handleUpload(event.target.files)}
                          multiple
                        />
                      </Button>
                    </Grid2>
                    <Grid2 item size={12}>
                      <Button sx={{ background: '#4DA235' }} variant="contained" size="large" onClick={() => { }}>
                        Submit
                      </Button>
                    </Grid2>
                  </Grid2>


                </Box>
              )}
            </Paper>

            <Modal
              open={isVerify}
              onClose={() => { setVerify(false) }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} justifyItems={'center'} >

                <Typography id="modal-modal-title" variant="h6" mt={4} mb={4} component="h2">
                  Verify Documents
                </Typography>
                <FormGroup >
                  <FormControlLabel control={<Checkbox />} label="I confirm that the details and documents are accurate." />
                </FormGroup>
                <Button sx={{ background: '#4DA235', marginTop: 2 }} variant="contained" size="large">
                  Verify
                </Button>
              </Box>
            </Modal>

            <Modal
              open={isReject}
              onClose={() => { setReject(false) }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}  >

                <Typography id="modal-modal-title" variant="h6" mb={4} component="h2">
                  Reject Lead
                </Typography>
                <FormGroup >
                  <TextField fullWidth
                    id="outlined-multiline-static"
                    label="Comments"
                    multiline
                    rows={4}
                    placeholder="Add comment for assignment rejection."
                    defaultValue={""}
                    onChange={event => setReason(event.target.value)}
                  />
                </FormGroup>
                <Button onClick={() => alert("ad")} sx={{ background: '#4DA235', marginTop: 2 }} variant="contained" size="large">
                  Submit
                </Button>
              </Box>
            </Modal>

            <Modal
              open={isVerify}
              onClose={() => { setVerify(false) }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} justifyItems={'center'} >
                <Typography id="modal-modal-title" variant="h6" mt={4} mb={4} component="h2">
                  Verify Documents
                </Typography>
                <FormGroup >
                  <FormControlLabel control={<Checkbox value={setChecked} onChange={(event) => setChecked(event.target.checked)} />} label="I confirm that the details and documents are accurate." />
                </FormGroup>
                <Button onClick={() => handleApprove()} disabled={!checked} sx={{ background: '#4DA235', marginTop: 2 }} variant="contained" size="large">
                  Verify
                </Button>
              </Box>
            </Modal>

            <Modal
              open={isReject}
              onClose={() => { setReject(false) }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}  >

                <Typography id="modal-modal-title" variant="h6" mb={4} component="h2">
                  Reject Lead
                </Typography>
                <FormGroup >
                  <TextField fullWidth
                    id="outlined-multiline-static"
                    label="Comments"
                    multiline
                    rows={4}
                    placeholder="Add comment for assignment rejection."
                    defaultValue={""}
                    onChange={(event) => setReason(event.target.value)}
                  />
                </FormGroup>
                <Button onClick={() => handleReject()} sx={{ background: '#4DA235', marginTop: 2 }} variant="contained" size="large">
                  Submit
                </Button>
              </Box>
            </Modal>

            <Modal
              open={isFR}
              onClose={() => { setFr(false) }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}  >

                <Typography id="modal-modal-title" variant="h6" mb={4} component="h2">
                  Rise FR
                </Typography>
                <FormGroup >
                  <TextField fullWidth
                    id="outlined-multiline-static"
                    label="Comments"
                    multiline
                    rows={4}
                    placeholder="Add comment for rising FR."
                    defaultValue={""}
                    onChange={(event) => setComment(event.target.value)}
                  />
                </FormGroup>
                <Button onClick={() => handleFr()} sx={{ background: '#4DA235', marginTop: 2 }} variant="contained" size="large">
                  Submit
                </Button>
              </Box>
            </Modal>

          </Container>
        </React.Fragment>
      </Layout >
    </>
  )
}

export default AddEditLeads